// ============================================================
// หน้า ImportPaymentHistory — นำเข้าไฟล์ข้อมูล : ประวัติการชำระเงิน
// ------------------------------------------------------------
// อ่านไฟล์ Excel ชีต "ประวัติการชำระเงิน" แล้วส่งเข้า API สร้างข้อมูลลูกค้า
//
// ⚠️ หมายเหตุสำคัญ (ยกมาตามพฤติกรรมเดิม ยังไม่ได้แก้)
//   - หน้านี้ไม่ได้ถูกลิงก์จากเมนู "นำเข้าไฟล์ข้อมูล" (เข้าได้ทาง URL /import-payment-history เท่านั้น)
//   - ข้อมูลที่อ่านจากไฟล์เป็นฟิลด์ของ "บิลค่าน้ำ" (บ้านเลขที่ เลขมาตร หน่วยที่ใช้)
//     แต่ตารางตรวจสอบด้านล่างแสดงคอลัมน์ของ "ข้อมูลลูกค้า" (ชื่อ เลขบัตร ที่อยู่)
//     ทำให้ตารางขึ้น "-" เกือบทุกช่อง — ต้องยืนยันกับผู้ใช้ก่อนว่าหน้านี้ควรทำงานแบบไหน
// ============================================================

import React, { Component } from "react";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar.js";
import excel_file from "../../assets/files/import_customer.xlsx";
import { tokens, success, alert, POST, getStorage, loading, ExcelDropZone, ActionIcon, ICON } from "../../shared/index.js";
import { transferText, buyText } from "../../shared/domain/customer-excel.js";

// ชื่อชีตที่หน้านี้รับ
const SHEET_NAME = "ประวัติการชำระเงิน";

export default class Import extends Component {
  state = {
    import: null, // ไฟล์ที่อ่านเข้ามา
    currentSheet: null, // ชีตที่ ReactExcel แปลงแล้ว
    data_import: null, // รายการที่เตรียมนำเข้า
  };

  componentDidMount() {
    loading(false);
  }

  // ---------- อ่านไฟล์ ----------

  handleFile = (file) => {
    readFile(file)
      .then((readedData) => {
        if (readedData.SheetNames[0] !== SHEET_NAME) {
          alert("info", "แจ้งเตือน", "ไฟล์ไม่ถูกต้อง");
          return;
        }
        // รอ 10ms ให้ ReactExcel อัปเดต currentSheet ก่อนอ่านข้อมูล
        this.setState({ import: readedData }, () => setTimeout(this.Import, 10));
      })
      .catch(console.error);
  };

  Import = () => {
    const data = generateObjects(this.state.currentSheet)
      .filter((item) => item["บ้านเลขที่"] !== "")
      .map((item) => ({
        address_number: item["บ้านเลขที่"],
        full_name: item["ชื่อ-นามสกุล"],
        date_of_note: item["วันที่จด"],
        current_gauge_number: item["เลขมาตรเดือนนี้"],
        last_gauge_number: item["เลขมาตรเดือนก่อน"],
        unit_used: item["หน่วยที่ใช้"],
        other_income: item["รายได้อื่น ๆ"],
        add_debt: item["เพิ่มหนี้"],
        reduce_debt: item["ลดหนี้"],
        remark_add_debt: item["หมายเหตุเพิ่มหนี้"],
        remark_reduce_debt: item["หมายเหตุลดหนี้"],
        // ค่าใช้จ่ายอื่นไม่ได้มาจากไฟล์นี้ ตั้งเป็น 0 ให้ backend คิดใหม่
        water_bill: 0,
        equipment_maintenance_fee: 0,
        common_expenses: 0,
        waste_cost: 0,
        cable_cost: 0,
        total_amount: 0,
        room_size: 0,
        status_meter: 0,
        setting_water_id: getStorage("water_id"),
        water_charge_start: 0,
        water_charge_end: 0,
        water_charge_price: 0,
        water_rate_list: [],
      }));

    if (data.length > 0) data.shift(); // แถวแรกคือแถวตัวอย่างในไฟล์ template
    this.setState({ data_import: data });
  };

  // ---------- บันทึก ----------

  Create_Import = async () => {
    loading(true);
    const result = await POST(tokens, `v1/TH/customer-manage/create/${getStorage("project_id")}`, { customer_list: this.state.data_import });
    if (result?.status) {
      this.setState({ data_import: null });
      success();
    }
    loading(false);
  };

  removeRow = (index) => {
    const data = [...this.state.data_import];
    data.splice(index, 1);
    this.setState({ data_import: data.length ? data : null });
  };

  render() {
    const { data_import } = this.state;
    const tdRequired = (value) => <td className={value ? "text-left" : "text-left bg-danger-light"}>{value || "-"}</td>;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="นำเข้าไฟล์ข้อมูล" page3="ประวัติการชำระเงิน" />
        <div className="body">
          <div className="p-3">
            {/* หัวข้อ + ปุ่ม */}
            <div className="w-100 d-flex justify-content-between mb-3">
              <h4 className="mb-3">
                <b>นำเข้าไฟล์ข้อมูล : ประวัติการชำระเงิน</b>
              </h4>
              <div className="d-flex">
                <button className="btn btn-outline-primary wpx-150 mx-1" onClick={() => (window.location.href = "/import")}>
                  <span className="icon-brand mr-2">{ICON.back}</span>ย้อนกลับ
                </button>
                {data_import && (
                  <button className="btn btn-danger wpx-150 mx-1" onClick={() => this.setState({ data_import: null })}>
                    ล้างค่า
                  </button>
                )}
                {data_import && (
                  <button className="btn btn-primary wpx-150 mx-1" onClick={this.Create_Import}>
                    นำเข้า
                  </button>
                )}
              </div>
            </div>

            {!data_import ? (
              <ExcelDropZone variant="page" templateFile={excel_file} templateName="import_customer.xlsx" templateLabel="template นำเข้าข้อมูลประวัติการชำระเงิน" onFile={this.handleFile} />
            ) : (
              <div className="card border-0 mb-3">
                <div className="card-header bg-dark-blue px-3 rounded-top">
                  <h4 className="text-white mb-0">
                    <b>ข้อมูลนำเข้า</b>
                  </h4>
                </div>
                <div className="p-3">
                  <div className="table-responsive">
                    <table className="table table-borderless table-striped">
                      <thead>
                        <tr className="bg-dark-blue text-white">
                          <th>ชื่อ - สกุล</th>
                          <th>เลขบัตรประชาชน</th>
                          <th>ที่อยู่</th>
                          <th>โทรศัพท์บ้าน</th>
                          <th>โทรศัพท์มือถือ</th>
                          <th>วันที่ส่งมอบ</th>
                          <th>วันที่มารับมอบ</th>
                          <th>วันที่โอน</th>
                          <th>สถานะการโอน</th>
                          <th>เลขที่เงินกู้</th>
                          <th>วงเงินกู้</th>
                          <th>เงินงวด</th>
                          <th>วันที่ทำสัญญา</th>
                          <th>ซื้ออาคารโดย</th>
                          <th>อาคาร</th>
                          <th>ชั้น</th>
                          <th>บ้านเลขที่</th>
                          <th>ขนาดห้อง (ตรม.)</th>
                          <th>ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data_import.map((item, index) => (
                          <tr key={index}>
                            {tdRequired(item.full_name)}
                            {tdRequired(item.id_card)}
                            {tdRequired(item.address)}
                            <td className="text-left">{item.home_phone || "-"}</td>
                            {tdRequired(item.mobile_phone)}
                            <td className="text-left">{item.delivery_date || "-"}</td>
                            <td className="text-left">{item.receive_date || "-"}</td>
                            <td className="text-left">{item.transfer_date || "-"}</td>
                            {tdRequired(item.status_transfer ? transferText(item.status_transfer) : null)}
                            <td className="text-left">{item.loan_number || "-"}</td>
                            <td className="text-left">{item.credit_limit || "-"}</td>
                            <td className="text-left">{item.installment || "-"}</td>
                            <td className="text-left">{item.contract_date || "-"}</td>
                            {tdRequired(item.status_buy_building ? buyText(item.status_buy_building) : null)}
                            {tdRequired(item.address_number)}
                            {tdRequired(item.building)}
                            {tdRequired(item.floor)}
                            {tdRequired(item.room_size)}
                            <td>
                              <ActionIcon color="danger" icon={ICON.delete} title="ลบแถวนี้" onClick={() => this.removeRow(index)} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* ตัวแปลงไฟล์ Excel ของ library — ซ่อนไว้ */}
            <div className="d-none">
              <ReactExcel initialData={this.state.import} onSheetUpdate={(sheet) => this.setState({ currentSheet: sheet })} activeSheetClassName="d-none" reactExcelClassName="table table-borderless table-striped" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
